import initialState from './lib/initial-normalised-state';
import mergeNormalisedData from './lib/merge-normalised-data';
import normaliseProductDetails from './lib/normalise-product-details';
import { PRODUCTS_DETAILS_FETCH_SUCCESS } from '../types';

const productDetails = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case PRODUCTS_DETAILS_FETCH_SUCCESS:
            return mergeNormalisedData(state, normaliseProductDetails(payload));
        default:
            return state;
    }
};

export default productDetails;
